export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Caramel Color (Powder)-346ff1ee32e13d88c0a1a22b41840664.pdf";